import { combineReducers } from 'redux';
import multireducer from 'multireducer';
import { routerReducer as routing } from 'react-router-redux';

import entities from 'widget/redux/client/reducers/entities';
import channelVideos from 'widget/redux/client/reducers/channel-videos';

import configuration from 'widget/redux/client/reducers/configuration';
import appSettings from 'widget/redux/client/reducers/app-settings';
import paginatedChannelVideos from 'widget/redux/client/reducers/paginated-channel-videos';
import currentChannelId from 'widget/redux/client/reducers/current-channel-id';
import search from 'widget/redux/client/reducers/search';
import channelInfo from 'widget/redux/client/reducers/channel-info';
import channelVideosLazyList from 'widget/redux/client/reducers/channel-videos-lazy-load';
import currentSiteUser from 'widget/redux/client/reducers/current-site-user';
import firstChannelVideoId from 'widget/redux/client/reducers/first-channel-video-id';
import biDefaultParams from 'widget/redux/client/reducers/bi-default-params';
import videoUrlsCache from 'widget/redux/client/reducers/video-urls-cache';
import { DATA_KEY as NEXT_VIDEO_KEY } from 'widget/data-components/next-channel-videos';
import { DATA_KEY as PAGINATED_VIDEOS_KEY } from 'widget/data-components/paginated-channel-videos';
import selectedVideoId from 'widget/redux/client/reducers/selected-video-id';
import videoPlaybackStatus from 'widget/redux/client/reducers/video-playback-status';
import isVideosTouched from 'widget/redux/client/reducers/is-videos-touched';
import experiments from 'shared/redux/client/reducers/experiments';
import vodSettings from 'shared/redux/client/reducers/vod-settings';

export default combineReducers({
  routing,
  search,

  entities,
  channelVideos,
  currentChannelId,
  channelInfo,
  currentSiteUser,
  firstChannelVideoId,
  lazyVideoLists: multireducer({
    [PAGINATED_VIDEOS_KEY]: paginatedChannelVideos,
    mobileSearch: channelVideosLazyList,
    mobileWidget: channelVideosLazyList,
    mobileOverlay: channelVideosLazyList,
    [NEXT_VIDEO_KEY]: channelVideosLazyList,
  }),
  videoUrlsCache,
  selectedVideoId,
  videoPlaybackStatus,
  isVideosTouched,

  configuration,
  appSettings,
  experiments,
  vodSettings,
  biDefaultParams,
});



// WEBPACK FOOTER //
// ./src/widget/redux/root-reducer.js